import { Component, Injector, OnInit } from '@angular/core';

import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { BaseComponent } from '../common/BaseComponent';
import { CommonService } from 'src/app/service/CommonService';

@Component({
  selector: 'app-not-authorize',
  templateUrl: './not-authorize.component.html'
})

export class NotAuthorizeComponent extends BaseComponent implements OnInit {
  user: User;
  appErrorPrefix: string = "bss.notAuthorize.error";
  errorCode = "";
  resourceUrl;

  constructor(public rest: UserService,
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.resourceUrl = sessionStorage.getItem("resource_url");
    console.log("Not Authorized:: resource_url from session: [" + this.resourceUrl + "]");

    if (!this.resourceUrl || this.resourceUrl === "null" || this.resourceUrl.trim().length === 0) {
      console.log("Not Authorized:: resource_url is empty, try get it from '?resource_url'");
      this.route.queryParams.subscribe(params => {
        const fullResourceUrl = (params['resource_url'])?.trim() ?? '';
        this.resourceUrl = CommonService.determineSigninUrl(fullResourceUrl);
        sessionStorage.setItem("resource_url", this.resourceUrl);
      });
    }
    console.log("Not Authorized:: resource_url: [" + this.resourceUrl + "]");

    if (!this.resourceUrl || this.resourceUrl === "null" || this.resourceUrl.trim().length === 0) {
      console.log("Not Authorized:: resource_url is empty, try get it from '?oam_res'");
      this.route.queryParams.subscribe(params => {
        const fullResourceUrl = (params['oam_res'])?.trim() ?? '';
        this.resourceUrl = CommonService.determineSigninUrl(fullResourceUrl);
        sessionStorage.setItem("resource_url", this.resourceUrl);
      });
    }
    console.log("Not Authorized:: resource_url: [" + this.resourceUrl + "]");
    
    let isEmailValidated = false;

    //rest call to /checkmail (return true/false)
    this.rest.checkEmail(this.user).subscribe(
    (response) => {
      console.log("check-email" + JSON.stringify(response));
      isEmailValidated = response.result == 0;

      if (!isEmailValidated) {
        //If email is not verifed, set user.emailVerifed = "false" and AuthGuard will use it          
        const sessionUser = sessionStorage.getItem("user");
        if (sessionUser) {
          let user: User = JSON.parse(sessionUser);
          user.emailVerified = "false";
          sessionStorage.setItem("user", JSON.stringify(user));
        }
                    
        this.router.navigateByUrl('secure/emailVerify');
      }
      else 
        this.router.navigateByUrl('secure/reqauthorized');
    }, (error) => { this.processError(error) });
  }
}
